import * as React from "react";
import Footer from "../components/Footer";

import { useTranslation } from 'react-i18next';
const MOCK_VERSIONS = [
  { id: 1, version: "1.0.0", date: "2025-01-15", author: "Creator", changes: "Initial version", status: "published" },
  { id: 2, version: "1.1.0", date: "2025-02-20", author: "Creator", changes: "Bug fixes and improvements", status: "published" },
  { id: 3, version: "1.2.0", date: "2025-03-10", author: "Creator", changes: "New flows added", status: "published" },
  { id: 4, version: "2.0.0-beta", date: "2025-04-01", author: "Creator", changes: "Complete API refactor", status: "draft" },
];

const statusLabels = { published: "Published", draft: "Draft", archived: "Archived" };
const statusColors = { published: "bg-green-900/30 text-green-400 border-green-700", draft: "bg-yellow-900/30 text-yellow-400 border-yellow-700", archived: "bg-slate-700/30 text-slate-400 border-slate-600" };

export default function VersionHistory({ skillId }) {
  const { t } = useTranslation();
  const [selectedVersion, setSelectedVersion] = React.useState(null);
  const versions = MOCK_VERSIONS;

  return (
    <div className="p-6 text-white max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">{t('version_history.version_history')}</h2>
        <span className="text-sm text-slate-400">{versions.length} versions</span>
      </div>

      <div className="relative border-l-2 border-slate-700 ml-3">
        {versions.map((v) => (
          <div key={v.id} className="mb-8 ml-6 relative">
            <span className="absolute -left-[31px] w-4 h-4 rounded-full bg-slate-900 border-2 border-blue-500" />
            <div className="flex items-center gap-3 mb-1">
              <span className="text-lg font-semibold text-blue-400">v{v.version}</span>
              <span className={`text-xs px-2 py-0.5 rounded border ${statusColors[v.status]}`}>
                {statusLabels[v.status]}
              </span>
            </div>
            <div className="text-xs text-slate-500 mb-2">{v.date} -- by {v.author}</div>
            <button
              onClick={() => setSelectedVersion(selectedVersion === v.id ? null : v.id)}
              className="text-sm text-slate-300 hover:text-white bg-slate-800 rounded-lg p-3 w-full text-left border border-slate-700"
            >
              {v.changes}
              {selectedVersion === v.id && (
                <div className="mt-2 pt-2 border-t border-slate-700 text-xs text-slate-400">
                  Changes: New flows added, prompt fixes, documentation updated.
                </div>
              )}
            </button>
          </div>
        ))}
      </div>
      <Footer />

    </div>
  );
};
